import React from 'react'
import { ScaleIcon, ClockIcon } from './icons'

export const formatPrice = (value) => `$${Math.round(value)}`

export const formatWeight = (min, max) => min === max ? `${min} tons` : `${min} - ${max} tons`

export const formatDays = (min, max) => min === max ? `${min} days` : `${min} - ${max} days`

export const formatCalculatedAt = (calculatedAt) => {
    const date = new Date(calculatedAt)
    return date.toLocaleString('en-US', { month: 'long', year: 'numeric' })
}

const TypicalPricesChart = ({ typicalPricesData, cityName }) => {
    if (!typicalPricesData?.rows?.length) return null

    const { rows, total_price_points, calculated_at, city_name } = typicalPricesData
    const displayCity = cityName || city_name || 'your area'

    return (
        <section className="typical-prices-chart">
            <div className="typical-prices-chart__header">
                <h2>Typical dumpster prices in {displayCity}</h2>
            </div>

            {/* Desktop table */}
            <div className="typical-prices-chart__table-wrap">
                <table className="typical-prices-chart__table">
                    <thead>
                        <tr>
                            <th>Size</th>
                            <th>Price range</th>
                            <th>Included weight</th>
                            <th>Included time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={i}>
                                <td className="typical-prices-chart__cell-size">{row.size_label}</td>
                                <td className="typical-prices-chart__cell-price">{formatPrice(row.low_price)} – {formatPrice(row.high_price)}</td>
                                <td>{formatWeight(row.min_weight, row.max_weight)}</td>
                                <td>{formatDays(row.min_days, row.max_days)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile cards */}
            <div className="typical-prices-chart__cards">
                {rows.map((row, i) => (
                    <div key={i} className="typical-prices-chart__card">
                        <div className="typical-prices-chart__card-top">
                            <span className="typical-prices-chart__card-size">{row.size_label} dumpster</span>
                            <span className="typical-prices-chart__cell-price">{formatPrice(row.low_price)} – {formatPrice(row.high_price)}</span>
                        </div>
                        <div className="typical-prices-chart__card-meta">
                            <div className="typical-prices-chart__meta-item">
                                <ScaleIcon />
                                <div className="typical-prices-chart__meta-text">
                                    <span className="typical-prices-chart__meta-label">Included weight</span>
                                    <span className="typical-prices-chart__meta-value">{formatWeight(row.min_weight, row.max_weight)}</span>
                                </div>
                            </div>
                            <div className="typical-prices-chart__meta-item">
                                <ClockIcon />
                                <div className="typical-prices-chart__meta-text">
                                    <span className="typical-prices-chart__meta-label">Included time</span>
                                    <span className="typical-prices-chart__meta-value">{formatDays(row.min_days, row.max_days)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Disclaimer */}
            <div className="typical-prices-chart__footer">
                <div className="typical-prices-chart__footer-body">
                    <p className="typical-prices-chart__disclosure">
                        Updated {formatCalculatedAt(calculated_at)}. Typical dumpster rental costs based on {total_price_points} recent price quotes in the {displayCity} market.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default TypicalPricesChart
